import {setupResearchCitations} from "pages/_research_citations";
import * as smoothscroll from "smoothscroll-polyfill";
import * as Animations from "./animations";
import "./spark.scss";

declare var $: any;

smoothscroll.polyfill();

document.addEventListener("DOMContentLoaded", () => {
  Animations.setupAnimations(["#use-case-reddit", "#use-case-reit", "#use-case-jobs"]);

  $(".owl-carousel").owlCarousel({
    loop: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    items: 1,
    smartSpeed: 750,
    margin: 20,
  });

  setupResearchCitations();
});
